export default "__VITE_ASSET__DVw1JlkI__"